import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import BrandLogo from "@xo-union/component-brand-logo";
import { createTrackableProps } from "@xo-union/tk-component-analytics";
import styles from "../../../../../css/index.css";
const TKBrandLogo = () => /*#__PURE__*/React.createElement("a", _extends({
  href: "/",
  className: styles.logo,
  "aria-label": "The Knot home"
}, createTrackableProps({
  selection: 'tk-logo'
})), /*#__PURE__*/React.createElement(BrandLogo, {
  name: "theknot",
  size: "lg",
  color: "secondary"
}));
export default TKBrandLogo;